import { render, staticRenderFns } from "./VideoSelector.vue?vue&type=template&id=5491943c&scoped=true"
import script from "./VideoSelector.vue?vue&type=script&lang=js"
export * from "./VideoSelector.vue?vue&type=script&lang=js"
import style0 from "./VideoSelector.vue?vue&type=style&index=0&id=5491943c&prod&lang=css"
import style1 from "./VideoSelector.vue?vue&type=style&index=1&id=5491943c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5491943c",
  null
  
)

export default component.exports